<div class="gwc-btnselect"
  [class.gwc-btnselect--error]="formControl.touched && !formControl.valid"> 
  @for (button of buttons; track button.value) {
    <button class="gwc-btnselect__item"
      [class.gwc-btnselect__item--active]="formControl.value === button.value"
      (click)="selectOption(button)"
      type="button"
      mat-stroked-button>
      <div class="gwc-btnselect__item-content">
        {{ button.label }}
      </div>
    </button>
  }
</div>
